import axios from 'axios'
import { Toast } from 'vant'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import router from '@/router'
import { getCache,clearCache } from '@/utils/cache'
import { removeToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 500000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers.Token = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode.default
  if (code === 401 || code === 403) {
    Toast.fail('请登录')
    // 重新登录，清除本地缓存
    removeToken()
    clearCache('user_id');
    clearCache('user_name');
    clearCache('user_phone');
    clearCache('user_idCard');
    clearCache('user_type');
    clearCache('user_view_permission');
    clearCache('user_create_permission');
    clearCache('user_audit_permission');
    clearCache('super_user');
    clearCache('show_linye_tabbar');
    clearCache('show_linye_manage_tabbar');
    clearCache('show_linye_customer_tabbar');
    clearCache('show_logistics_tabbar');
    clearCache('show_logistics_manage_tabbar');
    clearCache('show_logistics_customer_tabbar');
    // 检查将要跳转路由的元信息
    const currentRoute = router.currentRoute;
    let loginPath = null;
    if (currentRoute && currentRoute.meta && currentRoute.meta.loginPage) {
      // 如果当前路由有设置 meta.loginPage，则使用该路径
      loginPath = currentRoute.meta.loginPage;
    }
    // 执行重定向
    router.replace(loginPath);
    // router.replace('/auctionItem/login')
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。') // eslint-disable-line

  } else if (code === 500) {
    // Toast.fail(msg)
    console.log(msg)
    Toast.fail('系统异常')
    console.log(msg)
    return Promise.reject(new Error(msg))

  } else if (code !== 200 && code !== 60102 && code !== 60101 && code !== 60103 && code !== 60105 
    && code !== 60104 && code !== 80101 && code !== 70102 && code !== 50107 && code !== 70105 && code !== 50201) {
    if(code === 50101 || code === 50104 || code === 50109 || code === 50103 || code === 50202 || code === 70103 || code === 50203){
      Toast(msg)
    }
    return Promise.reject('error') // eslint-disable-line

  } else {
    return res.data
  }
},
error => {
  console.log('err' + error)
  let { message } = error
  if (message === 'Network Error') {
    message = '后端接口连接异常'
  } else if (message.includes('timeout')) {
    message = '系统接口请求超时'
  } else if (message.includes('Request failed with status code')) {
    message = '系统接口' + message.substr(message.length - 3) + '异常'
  }
  Toast.fail(message)
  return Promise.reject(error)
}
)

export default service
